export default __webpack_public_path__ + "static/zw-1ca50f375f0589cbc742064dce402edb.svg";